import BaseModel from "../BaseModel";
export default class SampleCertTypeCategory extends BaseModel {
	static entity = 'sampleCertTypeCategories';
	static primaryKey = "uuid";
	
	static fields() {
		return {
			uuid: this.attr(null),
			name: this.attr(null),
			description: this.attr(null),
		}
	}
	static ignoredLogFields(){
		return ['created_at', 'updated_at']
	}
	
	static name(){
		return "SampleTypeCategories"
	}
	
	static route(){
		return process.env.VUE_APP_RECORDED_API + '/sampleTypeCategories';
	}
	
	static apiConfig = {
		...super.apiConfig,
		headers: {
			"Accept": "application/json",
			"Authorization": process.env.VUE_APP_RECORDED_API_KEY,
			"VueRoute": window.location.href,
		}
	}
}
